
<template>
  <div class="yoga-spinner" style="display: block; margin: 0 auto;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="44"
      viewBox="0 0 34.9 43.7"
      class="beige"
    >
      <!-- eslint-disable-next-line -->
      <path
        class="st1"
        d="M34.5 41.9c-4.4-0.9-7.7-3.3-10.6-6.3 -3-3-4.9-6.7-6.4-11 -0.3 0.7-0.5 1.2-0.7 1.7 -2.1 5.3-5.4 9.7-10.2 13 -1.6 1.1-3.4 1.9-5.3 2.4 -0.3 0.1-0.6 0.1-0.8 0.1 -0.3-0.8 0.1-1 0.6-1.3 1.4-0.9 2.8-1.7 4.1-2.7 6.1-4.5 9.4-10.7 10.9-18 0.2-1.2 0-2.4 0-3.7 0-1.2 0.1-2.3 0.1-3.5 0-0.8 0-1.6 0-2.6 0.8-0.7 1.7-0.7 2.6 0 0 3 0 5.9 0 8.9 0 0.8 0.2 1.6 0.4 2.4 2.1 8.2 6.6 14.6 14.1 18.7C33.8 40.5 34.7 40.6 34.5 41.9z"
      />
      <!-- eslint-disable-next-line -->
      <path
        class="st0"
        d="M17.4 24c-6.5 0-11.7-5.3-11.7-11.7 0-6.5 5.3-11.8 11.7-11.8 6.5 0 11.7 5.3 11.7 11.8C29.2 18.8 23.9 24 17.4 24zM17.4 2.3c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C27.4 6.8 22.9 2.3 17.4 2.3z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: `LoadSpinner`,
};
</script>

<style>
</style>
